/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import NodŜarĝilo from './NodŜarĝilo.js';
import Nodo from './Nodo.js';
import Vorto from './Vorto.js';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import { useContext } from 'react';
import {FasadaLingvoKunteksto, VortaroLingvojKunteksto, ReĝimoKunteksto} from './Kunteksto.js';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {TEKSTOJ} from './tekstoj.js';
import {LINGVOJ} from './Lingvoj.js';
import Lingvo from './Lingvo.js';

function VortRedaktilo ( {modVorto, agorduModVorton, nodŝarĝilo} )
{
    function konservu()
    {
        const elVorto = document.getElementById ('vorto');
        const elOrdo = document.getElementById ('ordo');
        const elĈie = document.getElementById ('cie');
        if (vorto_id  != '')
        {    
           nodŝarĝilo.ŝanĝuVorton (modVorto.nodo.id, vorto_id, elVorto.value, elOrdo.value, elĈie.checked);
           agorduModVorton ({nodo:modVorto.nodo, vorto:modVorto.vorto, montri:false});
        }
        else
        {
           nodŝarĝilo.aldonuVorton (modVorto.nodo.id, modVorto.lingvo, elVorto.value, elOrdo.value);
           agorduModVorton ({nodo:modVorto.nodo, vorto:modVorto.vorto, montri:false});            
        }
    }
    
    function forigu ()
    {
        if (vorto_id != '')
        {
            nodŝarĝilo.foriguVorton (modVorto.nodo.id, vorto_id);
            agorduModVorton ({nodo:modVorto.nodo, vorto:null, montri:false});            
        }
    }
        
  const handleClose = () => agorduModVorton ({nodo:modVorto.nodo, vorto:modVorto.vorto, montri:false});
  console.log (modVorto);
  let vorto = modVorto.vorto;
  let vorto_teksto = vorto !== null ? vorto.vorto.replace('[[', '').replace(']]', '') : '';
  let vorto_titolo = vorto !== null ? vorto.vorto : TEKSTOJ.teksto('ESPRIMO_NOVA');
  let vorto_lingvo = vorto !== null ? LINGVOJ.lingvo(vorto.lingvo).nacinomo : LINGVOJ.lingvo (modVorto.lingvo).nacinomo;
  let vorto_id = vorto !=null ? vorto.id : '';
  let vorto_ordo = vorto != null ? vorto.ordo : '';
  let vorto_uzita = vorto != null ? vorto.uzita : '';
  const kopiuVortNumeron = () => navigator.clipboard.writeText (vorto_id);
  
  let vorto_ekzistas = vorto_id != '';
  let id_vico = vorto_ekzistas ? <><label>ID:</label> {vorto_id} <Button variant="outline-info" size="sm" onClick={kopiuVortNumeron}>{TEKSTOJ.teksto('BUTONO_KOPIU')}</Button><br /></>
                               : <></>;
  let butono_vico = vorto_ekzistas ? <Button variant="danger" onClick={forigu}>{TEKSTOJ.teksto('BUTONO_FORIGU')}</Button>
                               : <></>;
  let ĉie_vico = vorto_ekzistas ?         <Form.Check
            inline
            label=" Ŝanĝu la esprimon en ĉiuj nodoj"
            name="cie"
            type="checkbox"
            id="cie"
            defaultChecked={true}
          /> : <></>;
  return (
      <Modal show={modVorto.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{vorto_titolo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {id_vico}
        <label>{TEKSTOJ.teksto('LINGVO')}</label>: {vorto_lingvo}<br />
        <label>Uzita</label>: {vorto_uzita} foje<br />        
        <label htmlFor="ordo">{TEKSTOJ.teksto('ORDO')}</label>:<br />
        <input type="number" id="ordo" defaultValue={vorto_ordo} size="6" /><br />         
        <label htmlFor="vorto">{TEKSTOJ.teksto('ESPRIMO')}</label>:<br />
        <textarea cols="40" rows="5" id="vorto" name="vorto" defaultValue={vorto_teksto} />
        {ĉie_vico}
    </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
           {butono_vico}          
          <Button variant="primary" onClick={konservu}>{TEKSTOJ.teksto('BUTONO_KONSERVU')}</Button>
        </Modal.Footer>
      </Modal>
  );  
}

function KategorioElektilo({id, elektita})
{
    let kategorioj = [
 [1, TEKSTOJ.teksto('KATEGORIO_ĈAPITRO')],
 [2, TEKSTOJ.teksto('KATEGORIO_SUBĈAPITRO')],
 [3, TEKSTOJ.teksto('KATEGORIO_SUBSUBĈAPITRO')],
 [4, TEKSTOJ.teksto('KATEGORIO_KAPVORTO')],
 [5, TEKSTOJ.teksto('KATEGORIO_TIPO')],
 [6, TEKSTOJ.teksto('KATEGORIO_VERBO')],
 [7, TEKSTOJ.teksto('KATEGORIO_ADJEKTIVO')],
 [8, TEKSTOJ.teksto('KATEGORIO_ASOCIEBLA')],
 [9, TEKSTOJ.teksto('KATEGORIO_SUBVORTO')],
 [10,TEKSTOJ.teksto('KATEGORIO')],
 [11,TEKSTOJ.teksto('KATEGORIO_PARTO')]];
 
 var elementoj = new Array();
 
        for (let kat of kategorioj)
        {
            let elId = 'kat-' + kat[0];
            //console.log (elId);
            elementoj.push (<option id={elId} key={elId} value={kat[0]}>{kat[1]}</option>);
        }

        return (<Form.Select id={id} defaultValue={elektita}>
                {elementoj}
          </Form.Select>);     
}

function NodRedaktilo ( {modNodo, agorduModNodon, nodŝarĝilo} )
{
    function konservu()
    {
        const elPatro = document.getElementById ('PATRO');
        const elKategorio = document.getElementById ('KATEGORIO');
        const elOrdo = document.getElementById ('ORDO');
                
        if (nodo_id  != '')
        {            
           nodŝarĝilo.ŝanĝuNodon (nodo_id, elPatro.value, elKategorio.value, elOrdo.value);
           agorduModNodon ({nodo:null, montri:false});
        }
    }
    
    function forigu ()
    {
        if (nodo_id != '')
        {
            nodŝarĝilo.foriguNodon (nodo_id);
            agorduModNodon ({nodo:null, montri:false});
        }
    }
    
  const handleClose = () => agorduModNodon ({nodo:null, montri:false});
  console.log (modNodo);
  let nodo = modNodo.nodo;
  let nodo_id = nodo !=null ? nodo.id : '';
  let nodo_patro_id = nodo != null && nodo.patro_id != null ? nodo.patro_id : '';
  let nodo_kategorio = nodo != null ? nodo.kategorio : '';
  let nodo_ordo = nodo != null ? nodo.ordo : 0;
  let forigebla = nodo != null ? nodo.fina : false;
  
  const kopiuVortNumeron = () => navigator.clipboard.writeText (nodo_id);
  if (nodo != null)
  {
  console.log ("NodRedaktilo: " + nodo.id + ' de '+nodo.patro_id);
  }
  
 let butono_vico = forigebla ? <Button variant="danger" onClick={forigu}>Forigu</Button>
                               : <></>;
                               
  return (
      <Modal show={modNodo.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{TEKSTOJ.teksto('NODO')} {nodo_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label>ID:</label> {nodo_id} <Button variant="outline-info" size="sm" onClick={kopiuVortNumeron}>{TEKSTOJ.teksto('BUTONO_KOPIU')}</Button>
<br />
<label htmlFor="patro">{TEKSTOJ.teksto('PATRO')}</label>:<br />
        <input type="number" id="PATRO" defaultValue={nodo_patro_id} size="6" /><br />
        <label htmlFor="kategorio">{TEKSTOJ.teksto('KATEGORIO')}</label>:<br />
        <KategorioElektilo id="KATEGORIO" elektita={nodo_kategorio} />
        <label htmlFor="ordo">{TEKSTOJ.teksto('ORDO')}</label>:<br />
        <input type="number" id="ORDO" defaultValue={nodo_ordo} size="6" /><br />        
    </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
          {butono_vico}
          <Button variant="primary" onClick={konservu}>{TEKSTOJ.teksto('BUTONO_KONSERVU')}</Button>
        </Modal.Footer>
      </Modal>
  );      
}

function NodKreilo ( {modNovaNodo, agorduModNovanNodon, nodŝarĝilo} )
{
    function konservu()
    {
        const elKategorio = document.getElementById ('KATEGORIO');
        const elOrdo = document.getElementById ('ORDO');
       
        nodŝarĝilo.aldonuNodon (patro_id, elKategorio.value, elOrdo.value);
        agorduModNovanNodon ({nodo:null, montri:false});
    }
               
  const handleClose = () => agorduModNovanNodon ({patro:null, montri:false});
  console.log (modNovaNodo);
  let patro = modNovaNodo.patro;
  let patro_id = patro !=null ? patro.id : '';
  let nodo_kategorio = '';
  let nodo_ordo = 0;

  console.log ("NodKreilo: " + patro_id + ' de '+patro_id);

  return (
      <Modal show={modNovaNodo.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{TEKSTOJ.teksto('NODO_NOVA')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label htmlFor="patro">{TEKSTOJ.teksto('PATRO')}</label>: {patro_id}<br />
        <label htmlFor="kategorio">{TEKSTOJ.teksto('KATEGORIO')}</label>:<br />
        <KategorioElektilo id="KATEGORIO" elektita={nodo_kategorio} />    
        <label htmlFor="ordo">Ordo</label>:<br />
        <input type="number" id="ORDO" defaultValue={nodo_ordo} size="6" /><br />        
    </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
          <Button variant="primary" onClick={konservu}>{TEKSTOJ.teksto('BUTONO_KONSERVU')}</Button>
        </Modal.Footer>
      </Modal>
  );      
}

function NodUnuigilo ({modUnuigi, agorduModUnuigi, nodŝarĝilo} )
{
    function unuigu()
    {
        const elKun = document.getElementById ('KUN');
                
        if (nodo_id  != '')
        {            
           nodŝarĝilo.unuiguNodojn (nodo_id, elKun.value);
           agorduModUnuigi ({nodo:null, ŝarĝanta: false, montri:false});
        }
    }
       
  const handleClose = () => agorduModUnuigi ({nodo:null, ŝarĝanta: false, montri:false});
  
  let nodo = modUnuigi.nodo;
  let nodo_id = nodo !=null ? nodo.id : '';
  
  if (nodo != null)
  {
  console.log ("NodUnuigilo: " + nodo.id);
  }
  
  
  return (
      <Modal show={modUnuigi.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Nodo {nodo_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label htmlFor="kun">Unuigu kun</label>:<br />
        <input type="number" id="KUN" defaultValue="" size="6" /><br />
    </Modal.Body>
        <Modal.Footer>
        <div className="helpo">{TEKSTOJ.teksto('NODO_UNUIGU_HELPO')}</div>
          <Button variant="secondary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
          <Button variant="primary" onClick={unuigu}>{TEKSTOJ.teksto('BUTONO_UNUIGU')}</Button>
        </Modal.Footer>
      </Modal>
  );      
}

//----------------
/*
function GrupaNodRedaktilo ( {modNodoj, agorduModNodonj, nodŝarĝilo} )
{
    function konservu()
    {
        const elPatro = document.getElementById ('PATRO');
        const elKategorio = document.getElementById ('KATEGORIO');
                
        if (nodo_id  != '')
        {            
           nodŝarĝilo.ŝanĝuNodojn (nodo_id, elPatro.value, elKategorio.value, elOrdo.value);
           agorduModNodon ({nodo:null, montri:false});
        }
    }
    
    function forigu ()
    {
        if (nodo_id != '')
        {
            nodŝarĝilo.foriguNodon (nodo_id);
            agorduModNodon ({nodo:null, montri:false});
        }
    }
    
  const handleClose = () => agorduModNodon ({nodo:null, montri:false});
  console.log (modNodo);
  let nodo = modNodo.nodo;
  let nodo_id = nodo !=null ? nodo.id : '';
  let nodo_patro_id = nodo != null && nodo.patro_id != null ? nodo.patro_id : '';
  let nodo_kategorio = nodo != null ? nodo.kategorio : '';
  let nodo_ordo = nodo != null ? nodo.ordo : 0;
  let forigebla = nodo != null ? nodo.fina : false;
  
  const kopiuVortNumeron = () => navigator.clipboard.writeText (nodo_id);
  if (nodo != null)
  {
  console.log ("GrupaNodRedaktilo: " + nodo.id + ' de '+nodo.patro_id);
  }
  
 let butono_vico = forigebla ? <Button variant="danger" onClick={forigu}>Forigu</Button>
                               : <></>;
                               
  return (
      <Modal show={modNodo.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{TEKSTOJ.teksto('NODO')} {nodo_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label>ID:</label> {nodo_id} <Button variant="outline-info" size="sm" onClick={kopiuVortNumeron}>{TEKSTOJ.teksto('BUTONO_KOPIU')}</Button>
<br />
<label htmlFor="patro">{TEKSTOJ.teksto('PATRO')}</label>:<br />
        <input type="number" id="GPATRO" defaultValue={nodo_patro_id} size="6" /><br />
        <label htmlFor="kategorio">{TEKSTOJ.teksto('KATEGORIO')}</label>:<br />
        <KategorioElektilo id="GKATEGORIO" elektita={nodo_kategorio} />
    </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
          {butono_vico}
          <Button variant="primary" onClick={konservu}>{TEKSTOJ.teksto('BUTONO_KONSERVU')}</Button>
        </Modal.Footer>
      </Modal>
  );      
}
*/
function StrukturoVortoj ({agorduModVorton, nodo, lingvo, vortoj})
{
        var vortlisto = [];
        for (var vorto of vortoj)
        {
            var alklakante = alklakanteVorton (nodo, vorto, lingvo);
            vortlisto.push (<li key={vorto.id} onClick={alklakante}>{vorto.vorto.replace ('[[','').replace(']]', '')}</li>);
        }
        var alklakanteNovan = alklakanteVorton (nodo, null, lingvo);
        vortlisto.push (<li key={"nova"+nodo.id+"."+lingvo} onClick={alklakanteNovan}><em>{TEKSTOJ.teksto('ESPRIMO_ALDONU')}</em></li>);
        return (<ul>{vortlisto}</ul>);
        
        
    function alklakanteVorton (nodo, vorto, lingvo)
    {        
        return (function(){
            console.log (agorduModVorton);
            agorduModVorton({nodo: nodo, vorto: vorto, lingvo: lingvo, montri: true});            
        });
    }        
}

function LingvoElektiloSerĉilo ({id})
{
        const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);

        var valoro = vortarlingvoj[0];
        var elementoj = [];

        for (let lingvoid of vortarlingvoj)
        {
            let lingvo = LINGVOJ.lingvo (lingvoid);
            let elId = 'lingvo-' + id + '-' + lingvo.id;
            //console.log (elId);
            elementoj.push (<option id={elId} value={lingvo.id}>{lingvo.nacinomo}</option>);
        }

        return (<Form.Select id={id} defaultValue={valoro}>
             {elementoj}
          </Form.Select>)
}

function Serĉilo({nodŝarĝilo}){
   
    function serĉi()
    {
        const elVorto = document.getElementById ('sercatavorto');
        const elLingvo = document.getElementById ('lingvo');
        const elNodo =  document.getElementById ('sercatanodo');
      
        if (elVorto != null && elVorto.value.trim() > '')
        {
           nodŝarĝilo.ŝarĝuNodojnEnhavantajnVorton (elVorto.value, elLingvo.value);
        }
        else
        {
           if (elNodo.value.trim != "")
           {
                nodŝarĝilo.ŝarĝuNodojn (elNodo.value);
           }
       }
    }
    
    return (<Form>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="sercatanodo">{TEKSTOJ.teksto('SERĈU_NODO')}</Form.Label>
          <Form.Control as="input" type="text" id="sercatanodo" />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="sercatavorto">{TEKSTOJ.teksto('SERĈU_TITOLO')}</Form.Label>
          <Form.Control as="input" type="text" id="sercatavorto" />
        </Form.Group>
        <Form.Group className="mb-30">
          <Form.Label htmlFor="lingvo">{TEKSTOJ.teksto('SERĈU_LINGVO')}</Form.Label>
          <LingvoElektiloSerĉilo id="lingvo" />
        </Form.Group>
    <Button onClick = {serĉi}>{TEKSTOJ.teksto('SERĈU')}</Button>
    </Form>)
}


function etikedoDeKategorio (id)
{
    switch (id)
    {
        case 5: return ("♠ tipoj");
        case 6: return ("♣ verboj");
        case 7: return ("♥ adjektivoj");
        case 8: return ("♦ asocieblaj");
        case 11: return ("☼ partoj")
        default: return (TEKSTOJ.teksto('KATEGORIO') + " " + id);
    }
}

function StrukturoNodoKategorio ({nodo})
{
    switch (nodo.kategorio)
    {
        case 1: return (<h1>{TEKSTOJ.teksto('KATEGORIO_ĈAPITRO')}</h1>);
        case 2: return (<h2>{TEKSTOJ.teksto('KATEGORIO_SUBĈAPITRO')}</h2>);
        case 3: return (<h3>{TEKSTOJ.teksto('KATEGORIO_SUBSUBĈAPITRO')}</h3>);
        case 4: return (<strong>{TEKSTOJ.teksto('KATEGORIO_KAPVORTO')}</strong>);
        case 5: return (<span className="kategorio tipo">♠ {TEKSTOJ.teksto('KATEGORIO_TIPO')}</span>);
        case 6: return (<span className="kategorio verbo">♣ {TEKSTOJ.teksto('KATEGORIO_VERBO')}</span>);
        case 7: return (<span className="kategorio adjektivo">♥ {TEKSTOJ.teksto('KATEGORIO_ADJEKTIVO')}</span>);
        case 8: return (<span className="kategorio asociebla">♦ {TEKSTOJ.teksto('KATEGORIO_ASOCIEBLA')}</span>);
        case 11: return (<span className="kategorio parto">☼ {TEKSTOJ.teksto('KATEGORIO_PARTO')}</span>);
        case 9: return (<em>{TEKSTOJ.teksto('KATEGORIO_SUBVORTO')}</em>);
        case 10: return (<span className="kategorio">{etikedoDeKategorio(nodo.kategorio_filoj)}</span>);
        default: return (<span>kat {nodo.kategorio}</span>);
    }    
}

function StrukturoNodo ({nodo, nodŝarĝilo, agorduModVorton, agorduModNodon, agorduModUnuigi, estasKapo = false})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto);
    
    var lingvoj = vortarlingvoj;
    
    var kolumnoj = [];
    
    var sago = estasKapo ? '↑' : '→';
    var klaso = estasKapo ? 'kapo' : '';
    for (var lingvo of lingvoj)
    {
        var vortoj = nodo.vortojPorLingvo(lingvo);
        kolumnoj.push (<td key={nodo.id + "-" + lingvo}><StrukturoVortoj agorduModVorton={agorduModVorton} nodo={nodo} lingvo={lingvo} vortoj={vortoj} /></td>);
    }
    function alklakanteNodon ()
    {
        nodŝarĝilo.ŝarĝuNodojn (estasKapo ? nodo.patro_id : nodo.id);
    }
    
    function redaktonteNodon()
    {
        agorduModNodon ({nodo: nodo, montri: true}); 
    }
    
    function unuigonteNodon()
    {
        agorduModUnuigi ({nodo: nodo, montri: true}); 
    }
    
    function aldonanteNodonSub()
    {
        nodŝarĝilo.aldonuNodonSub (nodo.id);
    }
    
    const kopiuNodNumeron = () => navigator.clipboard.writeText (nodo.id);
  
    let sagobutono = nodo.fina ? <>⏊</> : <Button variant="outline-warning" size="sm" onClick={alklakanteNodon}>{sago}</Button>;
    
    return (
       <tr className={klaso}>
       <td><input type="checkbox" id={"NODOJ" + nodo.id} name={"NODOJ" + nodo.id} value={nodo.id} /></td>
       <td>{nodo.id}</td>
       <td><StrukturoNodoKategorio nodo={nodo} /></td>
           {kolumnoj}
       <td>
       <Button variant="outline-info" size="sm" onClick={kopiuNodNumeron}>{TEKSTOJ.teksto('BUTONO_KOPIU')}</Button>
       <Button variant="outline-primary" size="sm" onClick={redaktonteNodon}>{TEKSTOJ.teksto('BUTONO_REDAKTU')}</Button>
       <Button variant="outline-secondary" size="sm" onClick={unuigonteNodon}>{TEKSTOJ.teksto('BUTONO_UNUIGU')}</Button>
       {sagobutono}
       <br />
       <Button variant="outline-success" size="sm" onClick={aldonanteNodonSub}>{TEKSTOJ.teksto('BUTONO_ALDONU')}</Button>               
       </td>
      </tr>           
            );   
    }
    
function StrukturoNovaNodo ({nodŝarĝilo, agorduModNovanNodon, patro})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    const {reĝimo, agorduReĝimon} = useContext (ReĝimoKunteksto);
    
    var lingvoj = vortarlingvoj;
    
    var kolumnoj = [];
    
    for (var lingvo of lingvoj)
    {
        kolumnoj.push (<td key={"nova-" + lingvo}>&nbsp;</td>);
    }
    function kreonteNodon()
    {
        agorduModNovanNodon ({patro: patro, montri: true}); 
    }
    
    return (
    <tr>
       <td>&nbsp;</td>
       <td>&nbsp;</td>
       <td>&nbsp;</td>
           {kolumnoj}
       <td>
       <Button variant="outline-primary" size="sm" onClick={kreonteNodon}>{TEKSTOJ.teksto('BUTONO_ALDONU')}</Button>
       </td>
      </tr>
      );
}

function Strukturo( {nodoj, nodŝarĝilo})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    const [modVorto, agorduModVorton] = useState ({nodo: null, vorto: null, lingvo: null, montri: false});
    const [modNodo, agorduModNodon] = useState  ({nodo: null, montri: false});
    const [modNovaNodo, agorduModNovanNodon] = useState ({patro: null, montri: false});
    const [modUnuigi, agorduModUnuigi] = useState ({nodo:null, ŝarĝanta: false, montri:false});
    
    const reagordiStrukturon = function()
    {
        nodŝarĝilo.reagorduVortaron();
    };
    
    var lingvoj = vortarlingvoj;
    
    var kapLingvoj = [];
    for (var lingvo of lingvoj)
    {
        var nomoDeLingvo = LINGVOJ.lingvo(lingvo).nacinomo;
        kapLingvoj.push (<th key={lingvo}>{nomoDeLingvo}</th>);
    }
    
   nodŝarĝilo.agorduLingvojn (lingvoj); 
   if (nodoj === null)
   {
       nodŝarĝilo.ŝarĝuNodojn (null);
       return(<Alert dismissible variant="danger">
      <Alert.Heading>Neniu nodo trovita</Alert.Heading>
      <p>Atentu, eble mi ŝarĝas datumojn.</p>
    </Alert>
    );
   }
   else
   {
       // console.log (nodoj);
       var kapnodlisto = [];
       var kapnodo = null;
       for (var nodo of nodoj.kapnodoj)
       {
           kapnodlisto.push (<StrukturoNodo key={nodo.id} nodŝarĝilo={nodŝarĝilo} agorduModVorton={agorduModVorton} agorduModNodon={agorduModNodon} agorduModUnuigi={agorduModUnuigi} nodo={nodo}  estasKapo={true} />);
           kapnodo = nodo;
       }
              
       var nodlisto = [];
       for (var nodo of nodoj.listo)
       {
           nodlisto.push (<StrukturoNodo key={nodo.id}  nodŝarĝilo={nodŝarĝilo} agorduModVorton={agorduModVorton} agorduModNodon={agorduModNodon} agorduModUnuigi={agorduModUnuigi} nodo={nodo} />);
       }
       
       
       var kapo;
       if (nodoj.kapnodoj !== null)
       {
           kapo = <thead>
           <tr><th>{TEKSTOJ.teksto('ELEKTU')}</th><th>#</th><th>{TEKSTOJ.teksto('KATEGORIO')}</th>{kapLingvoj}<th>{TEKSTOJ.teksto('ILOJ')}</th></tr>
               {kapnodlisto}               
            </thead>;
       }       
       else
       {
            kapo = <thead>
            <tr><th>El.</th><th>#</th><th>kategorio</th>{kapLingvoj}<th>Iloj</th></tr>              
            </thead>;          
       }
       return (
               <>
       <VortRedaktilo modVorto={modVorto} agorduModVorton={agorduModVorton}  nodŝarĝilo={nodŝarĝilo} />
       <NodRedaktilo modNodo={modNodo} agorduModNodon={agorduModNodon} nodŝarĝilo={nodŝarĝilo} />
       <NodKreilo modNovaNodo={modNovaNodo} agorduModNovanNodon={agorduModNovanNodon} nodŝarĝilo={nodŝarĝilo} />
       <NodUnuigilo modUnuigi={modUnuigi} agorduModUnuigi={agorduModUnuigi} nodŝarĝilo={nodŝarĝilo} />
       <Serĉilo  nodŝarĝilo={nodŝarĝilo}/>
       
    <Table striped bordered hover>
        {kapo}
        <tbody>
        {nodlisto}
        <StrukturoNovaNodo key="novanodo" nodŝarĝilo={nodŝarĝilo} agorduModNovanNodon={agorduModNovanNodon} patro={kapnodo} />
        </tbody>
    </Table>
    <div>
    <p><em>Por pli efekta ŝarĝado de nodoj la nodoj portas informon pri sia pozicio en la strukturo. Tial post ŝanĝo de la strukturo necesas reagordi tiujn informojn.</em></p>
    <Button variant="outline-dark" size="sm" onClick={reagordiStrukturon}>Reagordi</Button>
    </div>
    </>
               );       
   }
}

export default Strukturo;